export default function signNumber(number: number, signNegative = true) {
  return number >= 0
    ? signNegative
      ? `+${number}`
      : `+${number}`
    : number < 0
      ? signNegative
        ? `-${number}`
        : `${number}`
      : '';
}
